import React, { useState } from 'react'
import { formatDistanceToNow } from 'date-fns'
import useInterval from '../hooks/use-interval'

const calculateRelativeTime = time => {
  return formatDistanceToNow(new Date(time))
}

const NotificationTime = ({ time }) => {
  const [relativeTime, setRelativeTime] = useState(calculateRelativeTime(time))

  useInterval(() => {
    setRelativeTime(calculateRelativeTime(time))
  }, 60000)

  return <span>{relativeTime} ago </span>
}

export default NotificationTime
